import type { CollapseProps } from "antd";

import EventInfo, { AppliableEventSettings, EventTags, NotAppliableEventSettings } from "./EventInfo";
import EventPreviewDetail from "./EventPreview";
import EventDetailContent, { EventCustomButtonContent } from "./EventDetail";
import { VolunteersEventType } from "../../context/EventContext/constants";
import { Dimension } from "../../components/FileUploadComponent/constants";

export type CultureProps = {
	Culture: string;
};

export type ImageUploadSettings = {
	label?: string;
	maxFileSize: string;
	extensions: ("jpeg" | "jpg" | "png")[];
	dimensions?: Dimension[];
};

export const EventConstants = {
	GENERAL: "Genel Özellikler",
	PREVIEW: "Proje Önizleme",
	DETAIL: "Proje Detayı",
	TAGS: "Proje Etiketleri",
	APPLIABLE: "Başvurulabilir Proje Özellikleri",
	NOT_APPLIABLE: "Başvurulamayan Proje Özellikleri",
	CUSTOM_BUTTON: "Özel Buton İçeriği",
};

const Cultures = ["tr-TR", "en-US"] as const;

const CultureLabels = {
	"tr-TR": {
		PREVIEW: "Proje Önizleme",
		DETAIL: "Proje Detayı",
		CUSTOM_BUTTON: "Özel Buton İçeriği",
	},
	"en-US": {
		PREVIEW: "Proje Önizleme - İngilizce",
		DETAIL: "Proje Detayı - İngilizce",
		CUSTOM_BUTTON: "Özel Buton İçeriği - İngilizce",
	},
} as const;

export const getEventItems = (
	eventType: VolunteersEventType | undefined,
	hasCustomButton: boolean | undefined
): CollapseProps["items"] => {
	const items: NonNullable<CollapseProps["items"]> = [
		{
			key: "1",
			label: EventConstants.GENERAL,
			children: <EventInfo />,
		},

		...Cultures.map((Culture) => ({
			key: `preview-${Culture}`,
			label: `${CultureLabels[Culture].PREVIEW}`,
			children: (
				<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
					<EventPreviewDetail Culture={Culture} />
				</div>
			),
		})),

		...Cultures.map((Culture) => ({
			key: `detail-${Culture}`,
			label: `${CultureLabels[Culture].DETAIL}`,
			children: (
				<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
					<EventDetailContent Culture={Culture} />
				</div>
			),
		})),

		{
			key: "4",
			label: EventConstants.TAGS,
			children: <EventTags />,
		},
	];

	if (eventType === VolunteersEventType.ApplicationRequired) {
		items.push({
			key: "5",
			label: EventConstants.APPLIABLE,
			children: <AppliableEventSettings />,
		});
	} else if (eventType === VolunteersEventType.ApplicationNotRequired) {
		items.push({
			key: "6",
			label: EventConstants.NOT_APPLIABLE,
			children: <NotAppliableEventSettings />,
		});

		if (hasCustomButton) {
			items.push(
				...Cultures.map(Culture => ({
					key: `custom-button-${Culture}`,
					label: `${CultureLabels[Culture].CUSTOM_BUTTON}`,
					children: (
						<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
							<EventCustomButtonContent Culture={Culture} />
						</div>
					),
				}))
			);
		}
	}

	return items;
};


export const EventItemKeys = [
	"1",
	"preview-tr-TR",
	"preview-en-US",
	"detail-tr-TR",
	"detail-en-US",
	"4",
	"5",
	"6",
	"custom-button-tr-TR",
	"custom-button-en-US",
];